import { BUILDING_LOCKED_TOOLTIP_POSITION } from '@/map-phaser-new/constants'
import type { BuildingConfigInterface } from '@/map-phaser-new/interfaces'

export const clubChampionshipConfig: BuildingConfigInterface = {
  textureKey: 'clubsBuildings',
  frameKey: 'club_championship',
  routeConfig: {
    routeName: 'ClubsChampionshipCompetitions',
    soundName: 'click-map-artefact',
    isRouteParamIdNeeded: false,
    changeScene: true,
  },
  positionX: 2361,
  positionY: 1374,
  depth: 4,
  originX: 0,
  keyForTranslateTitle: 'club.clubChampionship',
  buildingTitleConfig: {
    positionX: 2513.5,
    positionY: 1678,
    depth: 7,
    textConfig: {
      originX: 0.5,
      fontName: 'Roboto Condensed',
      fontSize: '24px',
      fontWeight: 'normal',
      fontStyle: 'italic',
      fontColor: '#fff',
    },
    backgroundImageConfig: {
      textureName: 'common',
      frameNameRightSide: 'right_side',
      frameNameRightSideLocked: 'right_side_locked',
      originX: 0.5,
      widthCorrection: 100,
      heightCorrection: 10,
    },
  },
  outlineConfig: {
    framePostFix: '_outline',
    depth: 6,
    originX: 0,
    positionByLevel: {
      '1': { positionX: 2361, positionY: 1374 },
    },
    textureKey: 'clubsBuildingsOutlines',
  },
  inputConfig: {
    useHandCursor: true,
  },
  buildingLockedConfig: {
    textureKey: 'clubsLockedBuildings',
    framePostfix: '_locked',
    lockImageTextureKey: 'lock',
    positionX: 2485.5,
    positionY: 1514,
    lockImageDepth: 6,
    depth: 5,
    tooltipConfig: {
      tooltipPosition: BUILDING_LOCKED_TOOLTIP_POSITION.Top,
      tooltipTextureHeight: '213px',
      tooltipTextureWidth: '444px',
      depth: 5,
      titleConfig: {
        originX: 0.5,
        fontSize: '30px',
        fontName: 'Roboto Condensed',
        fontWeight: 'normal',
        fontStyle: 'italic',
        fontColor: '#fff',
      },
      subtitleConfig: {
        originX: 0.5,
        originY: 0.5,
        fontName: 'Roboto Condensed',
        fontSize: '24px',
        fontWeight: 'normal',
        fontStyle: 'italic',
        fontColor: '#fff',
        replaceFontColor: '#fec742',
        tooltipSubtitleTranslateKey: 'common.comingSoon',
      },
      tooltipHideDelay: 2000,
      tooltipLeftTextureName: 'building_tooltip_left',
      tooltipRightTextureName: 'building_tooltip_right',
      tooltipTopTextureName: 'building_tooltip_top',
    },
  },
  buildingLabelNewConfig: {
    textureName: 'building_new_label',
    positionX: 2504,
    positionY: 1711,
    originX: 0.5,
    depth: 8,
  },
  buildingClLabelInfoConfig: {
    texture: 'common',
    backgroundFrame: 'bg',
    positionX: 2495.5,
    positionY: 1755,
    arrowLineFrame: 'line',
    arrowFramePostfix: 'Arrow',
    arrowOriginX: 0.5,
    arrowX: 35,
    arrowY: -2.5,
    badgeX: -35,
    badgeY: -5,
    badgeOriginX: 0.5,
    badgeFramePostfix: 'Badge',
    depth: 8,
    htmlTextConfig: {
      originX: 0.5,
      fontName: 'Roboto Condensed',
      fontSize: '32px',
      fontWeight: 'normal',
      fontStyle: 'italic',
      fontColor: '#fff',
    },
  },
}
